module.exports = __webpack_public_path__ + "f77946fef8ee8239f84e8f73f4e33f20.webp";